import React from 'react';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { ModalClose } from './ModalClose';
export var ModalHeader = function ModalHeader(_ref) {
  var _ref$closeButton = _ref.closeButton,
      closeButton = _ref$closeButton === void 0 ? true : _ref$closeButton,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Flex, {
    "data-test": "modal-header",
    position: "sticky",
    top: "0",
    left: "0",
    alignItems: "center",
    justifyContent: "space-between",
    pl: "m",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: "grey.light",
    backgroundColor: "base.white"
  }, /*#__PURE__*/React.createElement(Box, null, children), closeButton && /*#__PURE__*/React.createElement(ModalClose, null));
};